import { ReactNode } from 'react'

import { GuestReadinessStatus, UUID } from '@avantstay/arriere-clients/dist/arriereBackoffice'
import { SortDirection } from '@avantstay/data-grid'

import { HotelTapeChartStore } from '@new/domains/hotelTapeChart/stores/HotelTapeChartStore'

import { BaseTapeChartStore } from './stores/TapeChartStore'

export interface ListItemGroup {
  id?: UUID
  name?: string
  endAdornment?: () => ReactNode
  action?: VoidFunction
}

// itemKey represents listItem unique ID
export type ListItem<ListType> = ListType & {
  itemKey: UUID
  group?: ListItemGroup
  secondaryListItemId?: string
}

export interface DatesFormats {
  monthLabel?: string
  monthDay?: string
  weekDay?: string
}

export enum DateKind {
  regular = 'regular',
  weekend = 'weekend',
}

export enum BookingsColorMode {
  ReservationStatus = 'RESERVATION_STATUS',
  PaymentStatus = 'PAYMENT_STATUS',
}

export interface RowProps {
  rowStart: number
  rowSpan: number
}

export interface DayIndexes {
  startDayIndex: number
  endDayIndex: number
}

export interface AvailableDatesRange {
  checkIn: string
  checkOut: string
  ignoreBlocks?: boolean
}

export enum TapeType {
  Booking = 'booking',
  BlockedPeriod = 'blockedPeriod',
}

export enum TapeChartBookingsStatus {
  booked = 'BOOKED',
  cancelled = 'CANCELLED',
  checkedIn = 'CHECKED_IN',
  checkedOut = 'CHECKED_OUT',
  modified = 'MODIFIED',
  noShow = 'NO_SHOW',
  quoted = 'QUOTED',
  requested = 'REQUESTED',
  unassigned = 'UNASSIGNED',
  unassignedOverlay = 'UNASSIGNED_OVERLAY',
}

export enum BlockedPeriodType {
  EditableBlock = 'editableBlock',
  ReadOnlyBlock = 'readOnlyBlock',
}

export enum EconRowType {
  Normal = 'normal',
  HighRisk = 'highrisk',
  OffBoarded = 'offboarded',
}

export interface ListItemBasicInfo {
  id: string
  isIndividualHomeowner?: boolean
  isLowPriority?: boolean
  name: string
  regionName?: string
  unitNumber?: string
}

interface TapeContextListItem extends ListItemBasicInfo {
  status?: GuestReadinessStatus
}

export interface CreateTapeContextProps {
  hotelRoomTypeId?: string
  home?: TapeContextListItem
  period?: {
    fromDate?: string
    toDate?: string
  }
}

export interface SortOrderProps {
  sortByKey?: string
  sortOrder?: SortDirection
}

// Should include external stores as expected type
export type BaseStore = BaseTapeChartStore | HotelTapeChartStore
